var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box"},[_c('img',{attrs:{"src":require('@/assets/img/qietu/shelves.png'),"alt":""}}),_c('p',[_vm._v("文章已下架")])])
}
var staticRenderFns = []

export { render, staticRenderFns }